import * as types from './types'
import storage from '@/Plugins/storage'

export default () => ({
  pager: storage.session.getItem(types.STORE_PAGER)
    ? JSON.parse(storage.session.getItem(types.STORE_PAGER))
    : {
        pageSize: 10,
        orderBy: 'asc',
        sortBy: null,
        search: null,
        total: 0,
        page: 1,
        pages: 1,
      },
  isChecked: false,
  defaultWorkout: {
    id: null,
    orgId: null,
    class_id: null,
    name: '',
    videoId: null,
    videoUrl: null,
    youtubeUrl: null,
    duration: 0,
    archived: true,
    live: false,
  },
  workout: null,
  workouts: [],
  classes: null,
})
